import { createApolloClient } from '@gastrosoft/shared/graphql';
import { tokenManager } from '@/app/services/tokenManager';
import { notifySessionExpired } from '@gastrosoft/shared/auth';

const baseUrl = import.meta.env.VITE_ORDA_GRAPHQL_ENDPOINT;
export const posStaticContext = { posStatic: true } as const;

if (!baseUrl) {
  throw new Error('VITE_ORDA_GRAPHQL_ENDPOINT is not configured');
}

const client = createApolloClient({
  tokenManager,
  overrideHeaderName: 'X-Override-TenantId',
  credentials: 'include',
  defaultUri: `${baseUrl}/billing`,
  resolveUri: (operation) => {
    const { posStatic, schema } = operation.getContext();
    return posStatic || schema === 'PosSchema' ? `${baseUrl}/pos` : `${baseUrl}/billing`;
  },
  onSessionExpired: () => {
    notifySessionExpired();
  },
});

export default client;
